 import { gatewayRequestAxios } from './interceptor'
import { GATEWAY_API_APPS_URL, GATEWAY_API_GROUPS_URL } from '../constants/urls'

export const fetchApplications = (payload) => gatewayRequestAxios.get(GATEWAY_API_APPS_URL, {
    params: { q: payload, limit: 500 },
});

export const fetchGroups = (payload) => gatewayRequestAxios.get(GATEWAY_API_GROUPS_URL, {
    params: { q: payload, limit: 500 },
});

export const createGroup = (payload) => gatewayRequestAxios.post(GATEWAY_API_GROUPS_URL, payload)

export const updateGroup = (payload, groupId) => gatewayRequestAxios.patch(`${GATEWAY_API_GROUPS_URL}/${groupId}`, payload)

export const fetchGroup = (groupId) => gatewayRequestAxios.get(`${GATEWAY_API_GROUPS_URL}/${groupId}?membersLimit=1000`)
